import { Link } from "react-router-dom";

const Button = ({ text, href, className = "", onClick }) => {
  return href ? (
    <Link to={href}>
      <button className={`button brand ${className}`} onClick={onClick}>
        {text}
      </button>
    </Link>
  ) : (
    <button className={`button brand ${className}`} onClick={onClick}>
      {text}
    </button>
  );
};

export default Button;